/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TeamsTabsConfigRouteImport } from './routes/teams-tabs-config'
import { Route as AppRouteImport } from './routes/app'
import { Route as TeamsRouteRouteImport } from './routes/teams/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as NotFoundIndexRouteImport } from './routes/not-found/index'
import { Route as InvalidWorkspaceIndexRouteImport } from './routes/invalid-workspace/index'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppSplatRouteImport } from './routes/app/$'
import { Route as AppSuperviseRouteRouteImport } from './routes/_app/supervise/route'
import { Route as AppDashboardRouteRouteImport } from './routes/_app/dashboard/route'
import { Route as AppAdminRouteRouteImport } from './routes/_app/admin/route'
import { Route as TeamsTabsConfigIndexRouteImport } from './routes/teams/tabs-config/index'
import { Route as TeamsLoginIndexRouteImport } from './routes/teams/login/index'
import { Route as AuthTeamsIndexRouteImport } from './routes/auth/teams/index'
import { Route as AppTimerIndexRouteImport } from './routes/_app/timer/index'
import { Route as AppTestingIndexRouteImport } from './routes/_app/testing/index'
import { Route as AppTeamActivityIndexRouteImport } from './routes/_app/team-activity/index'
import { Route as AppSuperviseIndexRouteImport } from './routes/_app/supervise/index'
import { Route as AppReportsIndexRouteImport } from './routes/_app/reports/index'
import { Route as AppProfitabilityIndexRouteImport } from './routes/_app/profitability/index'
import { Route as AppOnboardingIndexRouteImport } from './routes/_app/onboarding/index'
import { Route as AppFeedIndexRouteImport } from './routes/_app/feed/index'
import { Route as AppDashboardIndexRouteImport } from './routes/_app/dashboard/index'
import { Route as AppCalendarIndexRouteImport } from './routes/_app/calendar/index'
import { Route as AppCalendarTimerIndexRouteImport } from './routes/_app/calendar-timer/index'
import { Route as AppAutomationIndexRouteImport } from './routes/_app/automation/index'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppAboutIndexRouteImport } from './routes/_app/about/index'
import { Route as AppSettingsWorkspaceRouteRouteImport } from './routes/_app/settings/workspace/route'
import { Route as AppSettingsProjectsRouteRouteImport } from './routes/_app/settings/projects/route'
import { Route as SettingsProjectviewIdIndexRouteImport } from './routes/settings/projectview/$id/index'
import { Route as AppSuperviseWorkinghoursIndexRouteImport } from './routes/_app/supervise/workinghours/index'
import { Route as AppSuperviseUserIndexRouteImport } from './routes/_app/supervise/user/index'
import { Route as AppSuperviseRulebreaksIndexRouteImport } from './routes/_app/supervise/rulebreaks/index'
import { Route as AppSuperviseActivityIndexRouteImport } from './routes/_app/supervise/activity/index'
import { Route as AppSettingsWorkspacesIndexRouteImport } from './routes/_app/settings/workspaces/index'
import { Route as AppSettingsWorkspaceIndexRouteImport } from './routes/_app/settings/workspace/index'
import { Route as AppSettingsTeamIndexRouteImport } from './routes/_app/settings/team/index'
import { Route as AppSettingsTagsIndexRouteImport } from './routes/_app/settings/tags/index'
import { Route as AppSettingsProjectsIndexRouteImport } from './routes/_app/settings/projects/index'
import { Route as AppSettingsClientsIndexRouteImport } from './routes/_app/settings/clients/index'
import { Route as AppDashboardSchedulesIndexRouteImport } from './routes/_app/dashboard/schedules/index'
import { Route as AppDashboardDetailedIndexRouteImport } from './routes/_app/dashboard/detailed/index'
import { Route as AppDashboardContingentIndexRouteImport } from './routes/_app/dashboard/contingent/index'
import { Route as AppAdminWorkspacesIndexRouteImport } from './routes/_app/admin/workspaces/index'
import { Route as AppAdminUsersIndexRouteImport } from './routes/_app/admin/users/index'
import { Route as AppAdminSubscriptionsIndexRouteImport } from './routes/_app/admin/subscriptions/index'
import { Route as AppAdminStatsIndexRouteImport } from './routes/_app/admin/stats/index'
import { Route as AppAdminNotificationsIndexRouteImport } from './routes/_app/admin/notifications/index'
import { Route as AppAccountProfileIndexRouteImport } from './routes/_app/account/profile/index'
import { Route as SettingsProjectviewIdReportRouteImport } from './routes/settings/projectview/$id/report'
import { Route as AppSettingsWorkspacesSplatRouteImport } from './routes/_app/settings/workspaces/$'
import { Route as AppSettingsProjectsIdRouteRouteImport } from './routes/_app/settings/projects/$id/route'
import { Route as AppSettingsClientsIdRouteRouteImport } from './routes/_app/settings/clients/$id/route'
import { Route as AppAdminWorkspacesWorkspaceIdRouteRouteImport } from './routes/_app/admin/workspaces/$workspaceId/route'
import { Route as AppAdminUsersUserIdRouteRouteImport } from './routes/_app/admin/users/$userId/route'
import { Route as AppSettingsWorkspaceWorkinghoursIndexRouteImport } from './routes/_app/settings/workspace/workinghours/index'
import { Route as AppSettingsWorkspaceTeamIndexRouteImport } from './routes/_app/settings/workspace/team/index'
import { Route as AppSettingsWorkspaceSubscriptionsIndexRouteImport } from './routes/_app/settings/workspace/subscriptions/index'
import { Route as AppSettingsWorkspaceProjecthoursIndexRouteImport } from './routes/_app/settings/workspace/projecthours/index'
import { Route as AppSettingsWorkspacePersonalizationIndexRouteImport } from './routes/_app/settings/workspace/personalization/index'
import { Route as AppSettingsTeamGroupsIndexRouteImport } from './routes/_app/settings/team/groups/index'
import { Route as AppSettingsProjectsTemplatesIndexRouteImport } from './routes/_app/settings/projects/templates/index'
import { Route as AppSettingsProjectsIdIndexRouteImport } from './routes/_app/settings/projects/$id/index'
import { Route as AppSettingsClientsIdIndexRouteImport } from './routes/_app/settings/clients/$id/index'
import { Route as AppAdminWorkspacesWorkspaceIdIndexRouteImport } from './routes/_app/admin/workspaces/$workspaceId/index'
import { Route as AppAdminUsersUserIdIndexRouteImport } from './routes/_app/admin/users/$userId/index'
import { Route as AppAdminWorkspacesWorkspaceIdUsersRouteImport } from './routes/_app/admin/workspaces/$workspaceId/users'
import { Route as AppAdminWorkspacesWorkspaceIdTimelineRouteImport } from './routes/_app/admin/workspaces/$workspaceId/timeline'
import { Route as AppAdminWorkspacesWorkspaceIdTasksRouteImport } from './routes/_app/admin/workspaces/$workspaceId/tasks'
import { Route as AppAdminWorkspacesWorkspaceIdProjectsRouteImport } from './routes/_app/admin/workspaces/$workspaceId/projects'
import { Route as AppAdminWorkspacesWorkspaceIdInvoicesRouteImport } from './routes/_app/admin/workspaces/$workspaceId/invoices'
import { Route as AppAdminWorkspacesWorkspaceIdClientsRouteImport } from './routes/_app/admin/workspaces/$workspaceId/clients'
import { Route as AppAdminWorkspacesWorkspaceIdBillingRouteImport } from './routes/_app/admin/workspaces/$workspaceId/billing'
import { Route as AppAdminWorkspacesWorkspaceIdAuditRouteImport } from './routes/_app/admin/workspaces/$workspaceId/audit'
import { Route as AppSettingsWorkspaceTeamGroupsIndexRouteImport } from './routes/_app/settings/workspace/team/groups/index'
import { Route as AppSettingsProjectsIdTasksIndexRouteImport } from './routes/_app/settings/projects/$id/tasks/index'
import { Route as AppSettingsProjectsIdReportIndexRouteImport } from './routes/_app/settings/projects/$id/report/index'
import { Route as AppSettingsProjectsIdHoursIndexRouteImport } from './routes/_app/settings/projects/$id/hours/index'
import { Route as AppSettingsClientsIdProjectsIndexRouteImport } from './routes/_app/settings/clients/$id/projects/index'

const TeamsTabsConfigRoute = TeamsTabsConfigRouteImport.update({
  id: '/teams-tabs-config',
  path: '/teams-tabs-config',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamsRouteRoute = TeamsRouteRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundIndexRoute = NotFoundIndexRouteImport.update({
  id: '/not-found/',
  path: '/not-found/',
  getParentRoute: () => rootRouteImport,
} as any)
const InvalidWorkspaceIndexRoute = InvalidWorkspaceIndexRouteImport.update({
  id: '/invalid-workspace/',
  path: '/invalid-workspace/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSplatRoute = AppSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AppRoute,
} as any)
const AppSuperviseRouteRoute = AppSuperviseRouteRouteImport.update({
  id: '/supervise',
  path: '/supervise',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDashboardRouteRoute = AppDashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminRouteRoute = AppAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRouteRoute,
} as any)
const TeamsTabsConfigIndexRoute = TeamsTabsConfigIndexRouteImport.update({
  id: '/tabs-config/',
  path: '/tabs-config/',
  getParentRoute: () => TeamsRouteRoute,
} as any)
const TeamsLoginIndexRoute = TeamsLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => TeamsRouteRoute,
} as any)
const AuthTeamsIndexRoute = AuthTeamsIndexRouteImport.update({
  id: '/auth/teams/',
  path: '/auth/teams/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTimerIndexRoute = AppTimerIndexRouteImport.update({
  id: '/timer/',
  path: '/timer/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTestingIndexRoute = AppTestingIndexRouteImport.update({
  id: '/testing/',
  path: '/testing/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTeamActivityIndexRoute = AppTeamActivityIndexRouteImport.update({
  id: '/team-activity/',
  path: '/team-activity/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSuperviseIndexRoute = AppSuperviseIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSuperviseRouteRoute,
} as any)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProfitabilityIndexRoute = AppProfitabilityIndexRouteImport.update({
  id: '/profitability/',
  path: '/profitability/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOnboardingIndexRoute = AppOnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFeedIndexRoute = AppFeedIndexRouteImport.update({
  id: '/feed/',
  path: '/feed/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDashboardIndexRoute = AppDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDashboardRouteRoute,
} as any)
const AppCalendarIndexRoute = AppCalendarIndexRouteImport.update({
  id: '/calendar/',
  path: '/calendar/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCalendarTimerIndexRoute = AppCalendarTimerIndexRouteImport.update({
  id: '/calendar-timer/',
  path: '/calendar-timer/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAutomationIndexRoute = AppAutomationIndexRouteImport.update({
  id: '/automation/',
  path: '/automation/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAboutIndexRoute = AppAboutIndexRouteImport.update({
  id: '/about/',
  path: '/about/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsWorkspaceRouteRoute =
  AppSettingsWorkspaceRouteRouteImport.update({
    id: '/settings/workspace',
    path: '/settings/workspace',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppSettingsProjectsRouteRoute =
  AppSettingsProjectsRouteRouteImport.update({
    id: '/settings/projects',
    path: '/settings/projects',
    getParentRoute: () => AppRouteRoute,
  } as any)
const SettingsProjectviewIdIndexRoute =
  SettingsProjectviewIdIndexRouteImport.update({
    id: '/settings/projectview/$id/',
    path: '/settings/projectview/$id/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppSuperviseWorkinghoursIndexRoute =
  AppSuperviseWorkinghoursIndexRouteImport.update({
    id: '/workinghours/',
    path: '/workinghours/',
    getParentRoute: () => AppSuperviseRouteRoute,
  } as any)
const AppSuperviseUserIndexRoute = AppSuperviseUserIndexRouteImport.update({
  id: '/user/',
  path: '/user/',
  getParentRoute: () => AppSuperviseRouteRoute,
} as any)
const AppSuperviseRulebreaksIndexRoute =
  AppSuperviseRulebreaksIndexRouteImport.update({
    id: '/rulebreaks/',
    path: '/rulebreaks/',
    getParentRoute: () => AppSuperviseRouteRoute,
  } as any)
const AppSuperviseActivityIndexRoute =
  AppSuperviseActivityIndexRouteImport.update({
    id: '/activity/',
    path: '/activity/',
    getParentRoute: () => AppSuperviseRouteRoute,
  } as any)
const AppSettingsWorkspacesIndexRoute =
  AppSettingsWorkspacesIndexRouteImport.update({
    id: '/settings/workspaces/',
    path: '/settings/workspaces/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppSettingsWorkspaceIndexRoute =
  AppSettingsWorkspaceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsWorkspaceRouteRoute,
  } as any)
const AppSettingsTeamIndexRoute = AppSettingsTeamIndexRouteImport.update({
  id: '/settings/team/',
  path: '/settings/team/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsTagsIndexRoute = AppSettingsTagsIndexRouteImport.update({
  id: '/settings/tags/',
  path: '/settings/tags/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsProjectsIndexRoute =
  AppSettingsProjectsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsProjectsRouteRoute,
  } as any)
const AppSettingsClientsIndexRoute = AppSettingsClientsIndexRouteImport.update({
  id: '/settings/clients/',
  path: '/settings/clients/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDashboardSchedulesIndexRoute =
  AppDashboardSchedulesIndexRouteImport.update({
    id: '/schedules/',
    path: '/schedules/',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any)
const AppDashboardDetailedIndexRoute =
  AppDashboardDetailedIndexRouteImport.update({
    id: '/detailed/',
    path: '/detailed/',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any)
const AppDashboardContingentIndexRoute =
  AppDashboardContingentIndexRouteImport.update({
    id: '/contingent/',
    path: '/contingent/',
    getParentRoute: () => AppDashboardRouteRoute,
  } as any)
const AppAdminWorkspacesIndexRoute = AppAdminWorkspacesIndexRouteImport.update({
  id: '/workspaces/',
  path: '/workspaces/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminUsersIndexRoute = AppAdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminSubscriptionsIndexRoute =
  AppAdminSubscriptionsIndexRouteImport.update({
    id: '/subscriptions/',
    path: '/subscriptions/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminStatsIndexRoute = AppAdminStatsIndexRouteImport.update({
  id: '/stats/',
  path: '/stats/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminNotificationsIndexRoute =
  AppAdminNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAccountProfileIndexRoute = AppAccountProfileIndexRouteImport.update({
  id: '/account/profile/',
  path: '/account/profile/',
  getParentRoute: () => AppRouteRoute,
} as any)
const SettingsProjectviewIdReportRoute =
  SettingsProjectviewIdReportRouteImport.update({
    id: '/settings/projectview/$id/report',
    path: '/settings/projectview/$id/report',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppSettingsWorkspacesSplatRoute =
  AppSettingsWorkspacesSplatRouteImport.update({
    id: '/settings/workspaces/$',
    path: '/settings/workspaces/$',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppSettingsProjectsIdRouteRoute =
  AppSettingsProjectsIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AppSettingsProjectsRouteRoute,
  } as any)
const AppSettingsClientsIdRouteRoute =
  AppSettingsClientsIdRouteRouteImport.update({
    id: '/settings/clients/$id',
    path: '/settings/clients/$id',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAdminWorkspacesWorkspaceIdRouteRoute =
  AppAdminWorkspacesWorkspaceIdRouteRouteImport.update({
    id: '/workspaces/$workspaceId',
    path: '/workspaces/$workspaceId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminUsersUserIdRouteRoute =
  AppAdminUsersUserIdRouteRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppSettingsWorkspaceWorkinghoursIndexRoute =
  AppSettingsWorkspaceWorkinghoursIndexRouteImport.update({
    id: '/workinghours/',
    path: '/workinghours/',
    getParentRoute: () => AppSettingsWorkspaceRouteRoute,
  } as any)
const AppSettingsWorkspaceTeamIndexRoute =
  AppSettingsWorkspaceTeamIndexRouteImport.update({
    id: '/team/',
    path: '/team/',
    getParentRoute: () => AppSettingsWorkspaceRouteRoute,
  } as any)
const AppSettingsWorkspaceSubscriptionsIndexRoute =
  AppSettingsWorkspaceSubscriptionsIndexRouteImport.update({
    id: '/subscriptions/',
    path: '/subscriptions/',
    getParentRoute: () => AppSettingsWorkspaceRouteRoute,
  } as any)
const AppSettingsWorkspaceProjecthoursIndexRoute =
  AppSettingsWorkspaceProjecthoursIndexRouteImport.update({
    id: '/projecthours/',
    path: '/projecthours/',
    getParentRoute: () => AppSettingsWorkspaceRouteRoute,
  } as any)
const AppSettingsWorkspacePersonalizationIndexRoute =
  AppSettingsWorkspacePersonalizationIndexRouteImport.update({
    id: '/personalization/',
    path: '/personalization/',
    getParentRoute: () => AppSettingsWorkspaceRouteRoute,
  } as any)
const AppSettingsTeamGroupsIndexRoute =
  AppSettingsTeamGroupsIndexRouteImport.update({
    id: '/settings/team/groups/',
    path: '/settings/team/groups/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppSettingsProjectsTemplatesIndexRoute =
  AppSettingsProjectsTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AppSettingsProjectsRouteRoute,
  } as any)
const AppSettingsProjectsIdIndexRoute =
  AppSettingsProjectsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsProjectsIdRouteRoute,
  } as any)
const AppSettingsClientsIdIndexRoute =
  AppSettingsClientsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsClientsIdRouteRoute,
  } as any)
const AppAdminWorkspacesWorkspaceIdIndexRoute =
  AppAdminWorkspacesWorkspaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminWorkspacesWorkspaceIdRouteRoute,
  } as any)
const AppAdminUsersUserIdIndexRoute =
  AppAdminUsersUserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminUsersUserIdRouteRoute,
  } as any)
const AppAdminWorkspacesWorkspaceIdUsersRoute =
  AppAdminWorkspacesWorkspaceIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AppAdminWorkspacesWorkspaceIdRouteRoute,
  } as any)
const AppAdminWorkspacesWorkspaceIdTimelineRoute =
  AppAdminWorkspacesWorkspaceIdTimelineRouteImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () => AppAdminWorkspacesWorkspaceIdRouteRoute,
  } as any)
const AppAdminWorkspacesWorkspaceIdTasksRoute =
  AppAdminWorkspacesWorkspaceIdTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AppAdminWorkspacesWorkspaceIdRouteRoute,
  } as any)
const AppAdminWorkspacesWorkspaceIdProjectsRoute =
  AppAdminWorkspacesWorkspaceIdProjectsRouteImport.update({
    id: '/projects',
    path: '/projects',
    getParentRoute: () => AppAdminWorkspacesWorkspaceIdRouteRoute,
  } as any)
const AppAdminWorkspacesWorkspaceIdInvoicesRoute =
  AppAdminWorkspacesWorkspaceIdInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => AppAdminWorkspacesWorkspaceIdRouteRoute,
  } as any)
const AppAdminWorkspacesWorkspaceIdClientsRoute =
  AppAdminWorkspacesWorkspaceIdClientsRouteImport.update({
    id: '/clients',
    path: '/clients',
    getParentRoute: () => AppAdminWorkspacesWorkspaceIdRouteRoute,
  } as any)
const AppAdminWorkspacesWorkspaceIdBillingRoute =
  AppAdminWorkspacesWorkspaceIdBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AppAdminWorkspacesWorkspaceIdRouteRoute,
  } as any)
const AppAdminWorkspacesWorkspaceIdAuditRoute =
  AppAdminWorkspacesWorkspaceIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AppAdminWorkspacesWorkspaceIdRouteRoute,
  } as any)
const AppSettingsWorkspaceTeamGroupsIndexRoute =
  AppSettingsWorkspaceTeamGroupsIndexRouteImport.update({
    id: '/team/groups/',
    path: '/team/groups/',
    getParentRoute: () => AppSettingsWorkspaceRouteRoute,
  } as any)
const AppSettingsProjectsIdTasksIndexRoute =
  AppSettingsProjectsIdTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => AppSettingsProjectsIdRouteRoute,
  } as any)
const AppSettingsProjectsIdReportIndexRoute =
  AppSettingsProjectsIdReportIndexRouteImport.update({
    id: '/report/',
    path: '/report/',
    getParentRoute: () => AppSettingsProjectsIdRouteRoute,
  } as any)
const AppSettingsProjectsIdHoursIndexRoute =
  AppSettingsProjectsIdHoursIndexRouteImport.update({
    id: '/hours/',
    path: '/hours/',
    getParentRoute: () => AppSettingsProjectsIdRouteRoute,
  } as any)
const AppSettingsClientsIdProjectsIndexRoute =
  AppSettingsClientsIdProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AppSettingsClientsIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/teams': typeof TeamsRouteRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/teams-tabs-config': typeof TeamsTabsConfigRoute
  '/admin': typeof AppAdminRouteRouteWithChildren
  '/dashboard': typeof AppDashboardRouteRouteWithChildren
  '/supervise': typeof AppSuperviseRouteRouteWithChildren
  '/app/$': typeof AppSplatRoute
  '/invalid-workspace/': typeof InvalidWorkspaceIndexRoute
  '/not-found/': typeof NotFoundIndexRoute
  '/settings/projects': typeof AppSettingsProjectsRouteRouteWithChildren
  '/settings/workspace': typeof AppSettingsWorkspaceRouteRouteWithChildren
  '/about/': typeof AppAboutIndexRoute
  '/admin/': typeof AppAdminIndexRoute
  '/automation/': typeof AppAutomationIndexRoute
  '/calendar-timer/': typeof AppCalendarTimerIndexRoute
  '/calendar/': typeof AppCalendarIndexRoute
  '/dashboard/': typeof AppDashboardIndexRoute
  '/feed/': typeof AppFeedIndexRoute
  '/onboarding/': typeof AppOnboardingIndexRoute
  '/profitability/': typeof AppProfitabilityIndexRoute
  '/reports/': typeof AppReportsIndexRoute
  '/supervise/': typeof AppSuperviseIndexRoute
  '/team-activity/': typeof AppTeamActivityIndexRoute
  '/testing/': typeof AppTestingIndexRoute
  '/timer/': typeof AppTimerIndexRoute
  '/auth/teams/': typeof AuthTeamsIndexRoute
  '/teams/login/': typeof TeamsLoginIndexRoute
  '/teams/tabs-config/': typeof TeamsTabsConfigIndexRoute
  '/admin/users/$userId': typeof AppAdminUsersUserIdRouteRouteWithChildren
  '/admin/workspaces/$workspaceId': typeof AppAdminWorkspacesWorkspaceIdRouteRouteWithChildren
  '/settings/clients/$id': typeof AppSettingsClientsIdRouteRouteWithChildren
  '/settings/projects/$id': typeof AppSettingsProjectsIdRouteRouteWithChildren
  '/settings/workspaces/$': typeof AppSettingsWorkspacesSplatRoute
  '/settings/projectview/$id/report': typeof SettingsProjectviewIdReportRoute
  '/account/profile/': typeof AppAccountProfileIndexRoute
  '/admin/notifications/': typeof AppAdminNotificationsIndexRoute
  '/admin/stats/': typeof AppAdminStatsIndexRoute
  '/admin/subscriptions/': typeof AppAdminSubscriptionsIndexRoute
  '/admin/users/': typeof AppAdminUsersIndexRoute
  '/admin/workspaces/': typeof AppAdminWorkspacesIndexRoute
  '/dashboard/contingent/': typeof AppDashboardContingentIndexRoute
  '/dashboard/detailed/': typeof AppDashboardDetailedIndexRoute
  '/dashboard/schedules/': typeof AppDashboardSchedulesIndexRoute
  '/settings/clients/': typeof AppSettingsClientsIndexRoute
  '/settings/projects/': typeof AppSettingsProjectsIndexRoute
  '/settings/tags/': typeof AppSettingsTagsIndexRoute
  '/settings/team/': typeof AppSettingsTeamIndexRoute
  '/settings/workspace/': typeof AppSettingsWorkspaceIndexRoute
  '/settings/workspaces/': typeof AppSettingsWorkspacesIndexRoute
  '/supervise/activity/': typeof AppSuperviseActivityIndexRoute
  '/supervise/rulebreaks/': typeof AppSuperviseRulebreaksIndexRoute
  '/supervise/user/': typeof AppSuperviseUserIndexRoute
  '/supervise/workinghours/': typeof AppSuperviseWorkinghoursIndexRoute
  '/settings/projectview/$id/': typeof SettingsProjectviewIdIndexRoute
  '/admin/workspaces/$workspaceId/audit': typeof AppAdminWorkspacesWorkspaceIdAuditRoute
  '/admin/workspaces/$workspaceId/billing': typeof AppAdminWorkspacesWorkspaceIdBillingRoute
  '/admin/workspaces/$workspaceId/clients': typeof AppAdminWorkspacesWorkspaceIdClientsRoute
  '/admin/workspaces/$workspaceId/invoices': typeof AppAdminWorkspacesWorkspaceIdInvoicesRoute
  '/admin/workspaces/$workspaceId/projects': typeof AppAdminWorkspacesWorkspaceIdProjectsRoute
  '/admin/workspaces/$workspaceId/tasks': typeof AppAdminWorkspacesWorkspaceIdTasksRoute
  '/admin/workspaces/$workspaceId/timeline': typeof AppAdminWorkspacesWorkspaceIdTimelineRoute
  '/admin/workspaces/$workspaceId/users': typeof AppAdminWorkspacesWorkspaceIdUsersRoute
  '/admin/users/$userId/': typeof AppAdminUsersUserIdIndexRoute
  '/admin/workspaces/$workspaceId/': typeof AppAdminWorkspacesWorkspaceIdIndexRoute
  '/settings/clients/$id/': typeof AppSettingsClientsIdIndexRoute
  '/settings/projects/$id/': typeof AppSettingsProjectsIdIndexRoute
  '/settings/projects/templates/': typeof AppSettingsProjectsTemplatesIndexRoute
  '/settings/team/groups/': typeof AppSettingsTeamGroupsIndexRoute
  '/settings/workspace/personalization/': typeof AppSettingsWorkspacePersonalizationIndexRoute
  '/settings/workspace/projecthours/': typeof AppSettingsWorkspaceProjecthoursIndexRoute
  '/settings/workspace/subscriptions/': typeof AppSettingsWorkspaceSubscriptionsIndexRoute
  '/settings/workspace/team/': typeof AppSettingsWorkspaceTeamIndexRoute
  '/settings/workspace/workinghours/': typeof AppSettingsWorkspaceWorkinghoursIndexRoute
  '/settings/clients/$id/projects/': typeof AppSettingsClientsIdProjectsIndexRoute
  '/settings/projects/$id/hours/': typeof AppSettingsProjectsIdHoursIndexRoute
  '/settings/projects/$id/report/': typeof AppSettingsProjectsIdReportIndexRoute
  '/settings/projects/$id/tasks/': typeof AppSettingsProjectsIdTasksIndexRoute
  '/settings/workspace/team/groups/': typeof AppSettingsWorkspaceTeamGroupsIndexRoute
}
export interface FileRoutesByTo {
  '/teams': typeof TeamsRouteRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/teams-tabs-config': typeof TeamsTabsConfigRoute
  '/app/$': typeof AppSplatRoute
  '/': typeof AppIndexRoute
  '/invalid-workspace': typeof InvalidWorkspaceIndexRoute
  '/not-found': typeof NotFoundIndexRoute
  '/about': typeof AppAboutIndexRoute
  '/admin': typeof AppAdminIndexRoute
  '/automation': typeof AppAutomationIndexRoute
  '/calendar-timer': typeof AppCalendarTimerIndexRoute
  '/calendar': typeof AppCalendarIndexRoute
  '/dashboard': typeof AppDashboardIndexRoute
  '/feed': typeof AppFeedIndexRoute
  '/onboarding': typeof AppOnboardingIndexRoute
  '/profitability': typeof AppProfitabilityIndexRoute
  '/reports': typeof AppReportsIndexRoute
  '/supervise': typeof AppSuperviseIndexRoute
  '/team-activity': typeof AppTeamActivityIndexRoute
  '/testing': typeof AppTestingIndexRoute
  '/timer': typeof AppTimerIndexRoute
  '/auth/teams': typeof AuthTeamsIndexRoute
  '/teams/login': typeof TeamsLoginIndexRoute
  '/teams/tabs-config': typeof TeamsTabsConfigIndexRoute
  '/settings/workspaces/$': typeof AppSettingsWorkspacesSplatRoute
  '/settings/projectview/$id/report': typeof SettingsProjectviewIdReportRoute
  '/account/profile': typeof AppAccountProfileIndexRoute
  '/admin/notifications': typeof AppAdminNotificationsIndexRoute
  '/admin/stats': typeof AppAdminStatsIndexRoute
  '/admin/subscriptions': typeof AppAdminSubscriptionsIndexRoute
  '/admin/users': typeof AppAdminUsersIndexRoute
  '/admin/workspaces': typeof AppAdminWorkspacesIndexRoute
  '/dashboard/contingent': typeof AppDashboardContingentIndexRoute
  '/dashboard/detailed': typeof AppDashboardDetailedIndexRoute
  '/dashboard/schedules': typeof AppDashboardSchedulesIndexRoute
  '/settings/clients': typeof AppSettingsClientsIndexRoute
  '/settings/projects': typeof AppSettingsProjectsIndexRoute
  '/settings/tags': typeof AppSettingsTagsIndexRoute
  '/settings/team': typeof AppSettingsTeamIndexRoute
  '/settings/workspace': typeof AppSettingsWorkspaceIndexRoute
  '/settings/workspaces': typeof AppSettingsWorkspacesIndexRoute
  '/supervise/activity': typeof AppSuperviseActivityIndexRoute
  '/supervise/rulebreaks': typeof AppSuperviseRulebreaksIndexRoute
  '/supervise/user': typeof AppSuperviseUserIndexRoute
  '/supervise/workinghours': typeof AppSuperviseWorkinghoursIndexRoute
  '/settings/projectview/$id': typeof SettingsProjectviewIdIndexRoute
  '/admin/workspaces/$workspaceId/audit': typeof AppAdminWorkspacesWorkspaceIdAuditRoute
  '/admin/workspaces/$workspaceId/billing': typeof AppAdminWorkspacesWorkspaceIdBillingRoute
  '/admin/workspaces/$workspaceId/clients': typeof AppAdminWorkspacesWorkspaceIdClientsRoute
  '/admin/workspaces/$workspaceId/invoices': typeof AppAdminWorkspacesWorkspaceIdInvoicesRoute
  '/admin/workspaces/$workspaceId/projects': typeof AppAdminWorkspacesWorkspaceIdProjectsRoute
  '/admin/workspaces/$workspaceId/tasks': typeof AppAdminWorkspacesWorkspaceIdTasksRoute
  '/admin/workspaces/$workspaceId/timeline': typeof AppAdminWorkspacesWorkspaceIdTimelineRoute
  '/admin/workspaces/$workspaceId/users': typeof AppAdminWorkspacesWorkspaceIdUsersRoute
  '/admin/users/$userId': typeof AppAdminUsersUserIdIndexRoute
  '/admin/workspaces/$workspaceId': typeof AppAdminWorkspacesWorkspaceIdIndexRoute
  '/settings/clients/$id': typeof AppSettingsClientsIdIndexRoute
  '/settings/projects/$id': typeof AppSettingsProjectsIdIndexRoute
  '/settings/projects/templates': typeof AppSettingsProjectsTemplatesIndexRoute
  '/settings/team/groups': typeof AppSettingsTeamGroupsIndexRoute
  '/settings/workspace/personalization': typeof AppSettingsWorkspacePersonalizationIndexRoute
  '/settings/workspace/projecthours': typeof AppSettingsWorkspaceProjecthoursIndexRoute
  '/settings/workspace/subscriptions': typeof AppSettingsWorkspaceSubscriptionsIndexRoute
  '/settings/workspace/team': typeof AppSettingsWorkspaceTeamIndexRoute
  '/settings/workspace/workinghours': typeof AppSettingsWorkspaceWorkinghoursIndexRoute
  '/settings/clients/$id/projects': typeof AppSettingsClientsIdProjectsIndexRoute
  '/settings/projects/$id/hours': typeof AppSettingsProjectsIdHoursIndexRoute
  '/settings/projects/$id/report': typeof AppSettingsProjectsIdReportIndexRoute
  '/settings/projects/$id/tasks': typeof AppSettingsProjectsIdTasksIndexRoute
  '/settings/workspace/team/groups': typeof AppSettingsWorkspaceTeamGroupsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/teams': typeof TeamsRouteRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/teams-tabs-config': typeof TeamsTabsConfigRoute
  '/_app/admin': typeof AppAdminRouteRouteWithChildren
  '/_app/dashboard': typeof AppDashboardRouteRouteWithChildren
  '/_app/supervise': typeof AppSuperviseRouteRouteWithChildren
  '/app/$': typeof AppSplatRoute
  '/_app/': typeof AppIndexRoute
  '/invalid-workspace/': typeof InvalidWorkspaceIndexRoute
  '/not-found/': typeof NotFoundIndexRoute
  '/_app/settings/projects': typeof AppSettingsProjectsRouteRouteWithChildren
  '/_app/settings/workspace': typeof AppSettingsWorkspaceRouteRouteWithChildren
  '/_app/about/': typeof AppAboutIndexRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/automation/': typeof AppAutomationIndexRoute
  '/_app/calendar-timer/': typeof AppCalendarTimerIndexRoute
  '/_app/calendar/': typeof AppCalendarIndexRoute
  '/_app/dashboard/': typeof AppDashboardIndexRoute
  '/_app/feed/': typeof AppFeedIndexRoute
  '/_app/onboarding/': typeof AppOnboardingIndexRoute
  '/_app/profitability/': typeof AppProfitabilityIndexRoute
  '/_app/reports/': typeof AppReportsIndexRoute
  '/_app/supervise/': typeof AppSuperviseIndexRoute
  '/_app/team-activity/': typeof AppTeamActivityIndexRoute
  '/_app/testing/': typeof AppTestingIndexRoute
  '/_app/timer/': typeof AppTimerIndexRoute
  '/auth/teams/': typeof AuthTeamsIndexRoute
  '/teams/login/': typeof TeamsLoginIndexRoute
  '/teams/tabs-config/': typeof TeamsTabsConfigIndexRoute
  '/_app/admin/users/$userId': typeof AppAdminUsersUserIdRouteRouteWithChildren
  '/_app/admin/workspaces/$workspaceId': typeof AppAdminWorkspacesWorkspaceIdRouteRouteWithChildren
  '/_app/settings/clients/$id': typeof AppSettingsClientsIdRouteRouteWithChildren
  '/_app/settings/projects/$id': typeof AppSettingsProjectsIdRouteRouteWithChildren
  '/_app/settings/workspaces/$': typeof AppSettingsWorkspacesSplatRoute
  '/settings/projectview/$id/report': typeof SettingsProjectviewIdReportRoute
  '/_app/account/profile/': typeof AppAccountProfileIndexRoute
  '/_app/admin/notifications/': typeof AppAdminNotificationsIndexRoute
  '/_app/admin/stats/': typeof AppAdminStatsIndexRoute
  '/_app/admin/subscriptions/': typeof AppAdminSubscriptionsIndexRoute
  '/_app/admin/users/': typeof AppAdminUsersIndexRoute
  '/_app/admin/workspaces/': typeof AppAdminWorkspacesIndexRoute
  '/_app/dashboard/contingent/': typeof AppDashboardContingentIndexRoute
  '/_app/dashboard/detailed/': typeof AppDashboardDetailedIndexRoute
  '/_app/dashboard/schedules/': typeof AppDashboardSchedulesIndexRoute
  '/_app/settings/clients/': typeof AppSettingsClientsIndexRoute
  '/_app/settings/projects/': typeof AppSettingsProjectsIndexRoute
  '/_app/settings/tags/': typeof AppSettingsTagsIndexRoute
  '/_app/settings/team/': typeof AppSettingsTeamIndexRoute
  '/_app/settings/workspace/': typeof AppSettingsWorkspaceIndexRoute
  '/_app/settings/workspaces/': typeof AppSettingsWorkspacesIndexRoute
  '/_app/supervise/activity/': typeof AppSuperviseActivityIndexRoute
  '/_app/supervise/rulebreaks/': typeof AppSuperviseRulebreaksIndexRoute
  '/_app/supervise/user/': typeof AppSuperviseUserIndexRoute
  '/_app/supervise/workinghours/': typeof AppSuperviseWorkinghoursIndexRoute
  '/settings/projectview/$id/': typeof SettingsProjectviewIdIndexRoute
  '/_app/admin/workspaces/$workspaceId/audit': typeof AppAdminWorkspacesWorkspaceIdAuditRoute
  '/_app/admin/workspaces/$workspaceId/billing': typeof AppAdminWorkspacesWorkspaceIdBillingRoute
  '/_app/admin/workspaces/$workspaceId/clients': typeof AppAdminWorkspacesWorkspaceIdClientsRoute
  '/_app/admin/workspaces/$workspaceId/invoices': typeof AppAdminWorkspacesWorkspaceIdInvoicesRoute
  '/_app/admin/workspaces/$workspaceId/projects': typeof AppAdminWorkspacesWorkspaceIdProjectsRoute
  '/_app/admin/workspaces/$workspaceId/tasks': typeof AppAdminWorkspacesWorkspaceIdTasksRoute
  '/_app/admin/workspaces/$workspaceId/timeline': typeof AppAdminWorkspacesWorkspaceIdTimelineRoute
  '/_app/admin/workspaces/$workspaceId/users': typeof AppAdminWorkspacesWorkspaceIdUsersRoute
  '/_app/admin/users/$userId/': typeof AppAdminUsersUserIdIndexRoute
  '/_app/admin/workspaces/$workspaceId/': typeof AppAdminWorkspacesWorkspaceIdIndexRoute
  '/_app/settings/clients/$id/': typeof AppSettingsClientsIdIndexRoute
  '/_app/settings/projects/$id/': typeof AppSettingsProjectsIdIndexRoute
  '/_app/settings/projects/templates/': typeof AppSettingsProjectsTemplatesIndexRoute
  '/_app/settings/team/groups/': typeof AppSettingsTeamGroupsIndexRoute
  '/_app/settings/workspace/personalization/': typeof AppSettingsWorkspacePersonalizationIndexRoute
  '/_app/settings/workspace/projecthours/': typeof AppSettingsWorkspaceProjecthoursIndexRoute
  '/_app/settings/workspace/subscriptions/': typeof AppSettingsWorkspaceSubscriptionsIndexRoute
  '/_app/settings/workspace/team/': typeof AppSettingsWorkspaceTeamIndexRoute
  '/_app/settings/workspace/workinghours/': typeof AppSettingsWorkspaceWorkinghoursIndexRoute
  '/_app/settings/clients/$id/projects/': typeof AppSettingsClientsIdProjectsIndexRoute
  '/_app/settings/projects/$id/hours/': typeof AppSettingsProjectsIdHoursIndexRoute
  '/_app/settings/projects/$id/report/': typeof AppSettingsProjectsIdReportIndexRoute
  '/_app/settings/projects/$id/tasks/': typeof AppSettingsProjectsIdTasksIndexRoute
  '/_app/settings/workspace/team/groups/': typeof AppSettingsWorkspaceTeamGroupsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/teams'
    | '/app'
    | '/teams-tabs-config'
    | '/admin'
    | '/dashboard'
    | '/supervise'
    | '/app/$'
    | '/invalid-workspace/'
    | '/not-found/'
    | '/settings/projects'
    | '/settings/workspace'
    | '/about/'
    | '/admin/'
    | '/automation/'
    | '/calendar-timer/'
    | '/calendar/'
    | '/dashboard/'
    | '/feed/'
    | '/onboarding/'
    | '/profitability/'
    | '/reports/'
    | '/supervise/'
    | '/team-activity/'
    | '/testing/'
    | '/timer/'
    | '/auth/teams/'
    | '/teams/login/'
    | '/teams/tabs-config/'
    | '/admin/users/$userId'
    | '/admin/workspaces/$workspaceId'
    | '/settings/clients/$id'
    | '/settings/projects/$id'
    | '/settings/workspaces/$'
    | '/settings/projectview/$id/report'
    | '/account/profile/'
    | '/admin/notifications/'
    | '/admin/stats/'
    | '/admin/subscriptions/'
    | '/admin/users/'
    | '/admin/workspaces/'
    | '/dashboard/contingent/'
    | '/dashboard/detailed/'
    | '/dashboard/schedules/'
    | '/settings/clients/'
    | '/settings/projects/'
    | '/settings/tags/'
    | '/settings/team/'
    | '/settings/workspace/'
    | '/settings/workspaces/'
    | '/supervise/activity/'
    | '/supervise/rulebreaks/'
    | '/supervise/user/'
    | '/supervise/workinghours/'
    | '/settings/projectview/$id/'
    | '/admin/workspaces/$workspaceId/audit'
    | '/admin/workspaces/$workspaceId/billing'
    | '/admin/workspaces/$workspaceId/clients'
    | '/admin/workspaces/$workspaceId/invoices'
    | '/admin/workspaces/$workspaceId/projects'
    | '/admin/workspaces/$workspaceId/tasks'
    | '/admin/workspaces/$workspaceId/timeline'
    | '/admin/workspaces/$workspaceId/users'
    | '/admin/users/$userId/'
    | '/admin/workspaces/$workspaceId/'
    | '/settings/clients/$id/'
    | '/settings/projects/$id/'
    | '/settings/projects/templates/'
    | '/settings/team/groups/'
    | '/settings/workspace/personalization/'
    | '/settings/workspace/projecthours/'
    | '/settings/workspace/subscriptions/'
    | '/settings/workspace/team/'
    | '/settings/workspace/workinghours/'
    | '/settings/clients/$id/projects/'
    | '/settings/projects/$id/hours/'
    | '/settings/projects/$id/report/'
    | '/settings/projects/$id/tasks/'
    | '/settings/workspace/team/groups/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/teams'
    | '/app'
    | '/teams-tabs-config'
    | '/app/$'
    | '/'
    | '/invalid-workspace'
    | '/not-found'
    | '/about'
    | '/admin'
    | '/automation'
    | '/calendar-timer'
    | '/calendar'
    | '/dashboard'
    | '/feed'
    | '/onboarding'
    | '/profitability'
    | '/reports'
    | '/supervise'
    | '/team-activity'
    | '/testing'
    | '/timer'
    | '/auth/teams'
    | '/teams/login'
    | '/teams/tabs-config'
    | '/settings/workspaces/$'
    | '/settings/projectview/$id/report'
    | '/account/profile'
    | '/admin/notifications'
    | '/admin/stats'
    | '/admin/subscriptions'
    | '/admin/users'
    | '/admin/workspaces'
    | '/dashboard/contingent'
    | '/dashboard/detailed'
    | '/dashboard/schedules'
    | '/settings/clients'
    | '/settings/projects'
    | '/settings/tags'
    | '/settings/team'
    | '/settings/workspace'
    | '/settings/workspaces'
    | '/supervise/activity'
    | '/supervise/rulebreaks'
    | '/supervise/user'
    | '/supervise/workinghours'
    | '/settings/projectview/$id'
    | '/admin/workspaces/$workspaceId/audit'
    | '/admin/workspaces/$workspaceId/billing'
    | '/admin/workspaces/$workspaceId/clients'
    | '/admin/workspaces/$workspaceId/invoices'
    | '/admin/workspaces/$workspaceId/projects'
    | '/admin/workspaces/$workspaceId/tasks'
    | '/admin/workspaces/$workspaceId/timeline'
    | '/admin/workspaces/$workspaceId/users'
    | '/admin/users/$userId'
    | '/admin/workspaces/$workspaceId'
    | '/settings/clients/$id'
    | '/settings/projects/$id'
    | '/settings/projects/templates'
    | '/settings/team/groups'
    | '/settings/workspace/personalization'
    | '/settings/workspace/projecthours'
    | '/settings/workspace/subscriptions'
    | '/settings/workspace/team'
    | '/settings/workspace/workinghours'
    | '/settings/clients/$id/projects'
    | '/settings/projects/$id/hours'
    | '/settings/projects/$id/report'
    | '/settings/projects/$id/tasks'
    | '/settings/workspace/team/groups'
  id:
    | '__root__'
    | '/_app'
    | '/teams'
    | '/app'
    | '/teams-tabs-config'
    | '/_app/admin'
    | '/_app/dashboard'
    | '/_app/supervise'
    | '/app/$'
    | '/_app/'
    | '/invalid-workspace/'
    | '/not-found/'
    | '/_app/settings/projects'
    | '/_app/settings/workspace'
    | '/_app/about/'
    | '/_app/admin/'
    | '/_app/automation/'
    | '/_app/calendar-timer/'
    | '/_app/calendar/'
    | '/_app/dashboard/'
    | '/_app/feed/'
    | '/_app/onboarding/'
    | '/_app/profitability/'
    | '/_app/reports/'
    | '/_app/supervise/'
    | '/_app/team-activity/'
    | '/_app/testing/'
    | '/_app/timer/'
    | '/auth/teams/'
    | '/teams/login/'
    | '/teams/tabs-config/'
    | '/_app/admin/users/$userId'
    | '/_app/admin/workspaces/$workspaceId'
    | '/_app/settings/clients/$id'
    | '/_app/settings/projects/$id'
    | '/_app/settings/workspaces/$'
    | '/settings/projectview/$id/report'
    | '/_app/account/profile/'
    | '/_app/admin/notifications/'
    | '/_app/admin/stats/'
    | '/_app/admin/subscriptions/'
    | '/_app/admin/users/'
    | '/_app/admin/workspaces/'
    | '/_app/dashboard/contingent/'
    | '/_app/dashboard/detailed/'
    | '/_app/dashboard/schedules/'
    | '/_app/settings/clients/'
    | '/_app/settings/projects/'
    | '/_app/settings/tags/'
    | '/_app/settings/team/'
    | '/_app/settings/workspace/'
    | '/_app/settings/workspaces/'
    | '/_app/supervise/activity/'
    | '/_app/supervise/rulebreaks/'
    | '/_app/supervise/user/'
    | '/_app/supervise/workinghours/'
    | '/settings/projectview/$id/'
    | '/_app/admin/workspaces/$workspaceId/audit'
    | '/_app/admin/workspaces/$workspaceId/billing'
    | '/_app/admin/workspaces/$workspaceId/clients'
    | '/_app/admin/workspaces/$workspaceId/invoices'
    | '/_app/admin/workspaces/$workspaceId/projects'
    | '/_app/admin/workspaces/$workspaceId/tasks'
    | '/_app/admin/workspaces/$workspaceId/timeline'
    | '/_app/admin/workspaces/$workspaceId/users'
    | '/_app/admin/users/$userId/'
    | '/_app/admin/workspaces/$workspaceId/'
    | '/_app/settings/clients/$id/'
    | '/_app/settings/projects/$id/'
    | '/_app/settings/projects/templates/'
    | '/_app/settings/team/groups/'
    | '/_app/settings/workspace/personalization/'
    | '/_app/settings/workspace/projecthours/'
    | '/_app/settings/workspace/subscriptions/'
    | '/_app/settings/workspace/team/'
    | '/_app/settings/workspace/workinghours/'
    | '/_app/settings/clients/$id/projects/'
    | '/_app/settings/projects/$id/hours/'
    | '/_app/settings/projects/$id/report/'
    | '/_app/settings/projects/$id/tasks/'
    | '/_app/settings/workspace/team/groups/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  TeamsRouteRoute: typeof TeamsRouteRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  TeamsTabsConfigRoute: typeof TeamsTabsConfigRoute
  InvalidWorkspaceIndexRoute: typeof InvalidWorkspaceIndexRoute
  NotFoundIndexRoute: typeof NotFoundIndexRoute
  AuthTeamsIndexRoute: typeof AuthTeamsIndexRoute
  SettingsProjectviewIdReportRoute: typeof SettingsProjectviewIdReportRoute
  SettingsProjectviewIdIndexRoute: typeof SettingsProjectviewIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/teams-tabs-config': {
      id: '/teams-tabs-config'
      path: '/teams-tabs-config'
      fullPath: '/teams-tabs-config'
      preLoaderRoute: typeof TeamsTabsConfigRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teams': {
      id: '/teams'
      path: '/teams'
      fullPath: '/teams'
      preLoaderRoute: typeof TeamsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-found/': {
      id: '/not-found/'
      path: '/not-found'
      fullPath: '/not-found/'
      preLoaderRoute: typeof NotFoundIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invalid-workspace/': {
      id: '/invalid-workspace/'
      path: '/invalid-workspace'
      fullPath: '/invalid-workspace/'
      preLoaderRoute: typeof InvalidWorkspaceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/$': {
      id: '/app/$'
      path: '/$'
      fullPath: '/app/$'
      preLoaderRoute: typeof AppSplatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/supervise': {
      id: '/_app/supervise'
      path: '/supervise'
      fullPath: '/supervise'
      preLoaderRoute: typeof AppSuperviseRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/teams/tabs-config/': {
      id: '/teams/tabs-config/'
      path: '/tabs-config'
      fullPath: '/teams/tabs-config/'
      preLoaderRoute: typeof TeamsTabsConfigIndexRouteImport
      parentRoute: typeof TeamsRouteRoute
    }
    '/teams/login/': {
      id: '/teams/login/'
      path: '/login'
      fullPath: '/teams/login/'
      preLoaderRoute: typeof TeamsLoginIndexRouteImport
      parentRoute: typeof TeamsRouteRoute
    }
    '/auth/teams/': {
      id: '/auth/teams/'
      path: '/auth/teams'
      fullPath: '/auth/teams/'
      preLoaderRoute: typeof AuthTeamsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/timer/': {
      id: '/_app/timer/'
      path: '/timer'
      fullPath: '/timer/'
      preLoaderRoute: typeof AppTimerIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/testing/': {
      id: '/_app/testing/'
      path: '/testing'
      fullPath: '/testing/'
      preLoaderRoute: typeof AppTestingIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/team-activity/': {
      id: '/_app/team-activity/'
      path: '/team-activity'
      fullPath: '/team-activity/'
      preLoaderRoute: typeof AppTeamActivityIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/supervise/': {
      id: '/_app/supervise/'
      path: '/'
      fullPath: '/supervise/'
      preLoaderRoute: typeof AppSuperviseIndexRouteImport
      parentRoute: typeof AppSuperviseRouteRoute
    }
    '/_app/reports/': {
      id: '/_app/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/profitability/': {
      id: '/_app/profitability/'
      path: '/profitability'
      fullPath: '/profitability/'
      preLoaderRoute: typeof AppProfitabilityIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/onboarding/': {
      id: '/_app/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof AppOnboardingIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/feed/': {
      id: '/_app/feed/'
      path: '/feed'
      fullPath: '/feed/'
      preLoaderRoute: typeof AppFeedIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/dashboard/': {
      id: '/_app/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AppDashboardIndexRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/_app/calendar/': {
      id: '/_app/calendar/'
      path: '/calendar'
      fullPath: '/calendar/'
      preLoaderRoute: typeof AppCalendarIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/calendar-timer/': {
      id: '/_app/calendar-timer/'
      path: '/calendar-timer'
      fullPath: '/calendar-timer/'
      preLoaderRoute: typeof AppCalendarTimerIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/automation/': {
      id: '/_app/automation/'
      path: '/automation'
      fullPath: '/automation/'
      preLoaderRoute: typeof AppAutomationIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/about/': {
      id: '/_app/about/'
      path: '/about'
      fullPath: '/about/'
      preLoaderRoute: typeof AppAboutIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/workspace': {
      id: '/_app/settings/workspace'
      path: '/settings/workspace'
      fullPath: '/settings/workspace'
      preLoaderRoute: typeof AppSettingsWorkspaceRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/projects': {
      id: '/_app/settings/projects'
      path: '/settings/projects'
      fullPath: '/settings/projects'
      preLoaderRoute: typeof AppSettingsProjectsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/settings/projectview/$id/': {
      id: '/settings/projectview/$id/'
      path: '/settings/projectview/$id'
      fullPath: '/settings/projectview/$id/'
      preLoaderRoute: typeof SettingsProjectviewIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/supervise/workinghours/': {
      id: '/_app/supervise/workinghours/'
      path: '/workinghours'
      fullPath: '/supervise/workinghours/'
      preLoaderRoute: typeof AppSuperviseWorkinghoursIndexRouteImport
      parentRoute: typeof AppSuperviseRouteRoute
    }
    '/_app/supervise/user/': {
      id: '/_app/supervise/user/'
      path: '/user'
      fullPath: '/supervise/user/'
      preLoaderRoute: typeof AppSuperviseUserIndexRouteImport
      parentRoute: typeof AppSuperviseRouteRoute
    }
    '/_app/supervise/rulebreaks/': {
      id: '/_app/supervise/rulebreaks/'
      path: '/rulebreaks'
      fullPath: '/supervise/rulebreaks/'
      preLoaderRoute: typeof AppSuperviseRulebreaksIndexRouteImport
      parentRoute: typeof AppSuperviseRouteRoute
    }
    '/_app/supervise/activity/': {
      id: '/_app/supervise/activity/'
      path: '/activity'
      fullPath: '/supervise/activity/'
      preLoaderRoute: typeof AppSuperviseActivityIndexRouteImport
      parentRoute: typeof AppSuperviseRouteRoute
    }
    '/_app/settings/workspaces/': {
      id: '/_app/settings/workspaces/'
      path: '/settings/workspaces'
      fullPath: '/settings/workspaces/'
      preLoaderRoute: typeof AppSettingsWorkspacesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/workspace/': {
      id: '/_app/settings/workspace/'
      path: '/'
      fullPath: '/settings/workspace/'
      preLoaderRoute: typeof AppSettingsWorkspaceIndexRouteImport
      parentRoute: typeof AppSettingsWorkspaceRouteRoute
    }
    '/_app/settings/team/': {
      id: '/_app/settings/team/'
      path: '/settings/team'
      fullPath: '/settings/team/'
      preLoaderRoute: typeof AppSettingsTeamIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/tags/': {
      id: '/_app/settings/tags/'
      path: '/settings/tags'
      fullPath: '/settings/tags/'
      preLoaderRoute: typeof AppSettingsTagsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/projects/': {
      id: '/_app/settings/projects/'
      path: '/'
      fullPath: '/settings/projects/'
      preLoaderRoute: typeof AppSettingsProjectsIndexRouteImport
      parentRoute: typeof AppSettingsProjectsRouteRoute
    }
    '/_app/settings/clients/': {
      id: '/_app/settings/clients/'
      path: '/settings/clients'
      fullPath: '/settings/clients/'
      preLoaderRoute: typeof AppSettingsClientsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/dashboard/schedules/': {
      id: '/_app/dashboard/schedules/'
      path: '/schedules'
      fullPath: '/dashboard/schedules/'
      preLoaderRoute: typeof AppDashboardSchedulesIndexRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/_app/dashboard/detailed/': {
      id: '/_app/dashboard/detailed/'
      path: '/detailed'
      fullPath: '/dashboard/detailed/'
      preLoaderRoute: typeof AppDashboardDetailedIndexRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/_app/dashboard/contingent/': {
      id: '/_app/dashboard/contingent/'
      path: '/contingent'
      fullPath: '/dashboard/contingent/'
      preLoaderRoute: typeof AppDashboardContingentIndexRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/_app/admin/workspaces/': {
      id: '/_app/admin/workspaces/'
      path: '/workspaces'
      fullPath: '/admin/workspaces/'
      preLoaderRoute: typeof AppAdminWorkspacesIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/users/': {
      id: '/_app/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AppAdminUsersIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/subscriptions/': {
      id: '/_app/admin/subscriptions/'
      path: '/subscriptions'
      fullPath: '/admin/subscriptions/'
      preLoaderRoute: typeof AppAdminSubscriptionsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/stats/': {
      id: '/_app/admin/stats/'
      path: '/stats'
      fullPath: '/admin/stats/'
      preLoaderRoute: typeof AppAdminStatsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/notifications/': {
      id: '/_app/admin/notifications/'
      path: '/notifications'
      fullPath: '/admin/notifications/'
      preLoaderRoute: typeof AppAdminNotificationsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/account/profile/': {
      id: '/_app/account/profile/'
      path: '/account/profile'
      fullPath: '/account/profile/'
      preLoaderRoute: typeof AppAccountProfileIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/settings/projectview/$id/report': {
      id: '/settings/projectview/$id/report'
      path: '/settings/projectview/$id/report'
      fullPath: '/settings/projectview/$id/report'
      preLoaderRoute: typeof SettingsProjectviewIdReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/settings/workspaces/$': {
      id: '/_app/settings/workspaces/$'
      path: '/settings/workspaces/$'
      fullPath: '/settings/workspaces/$'
      preLoaderRoute: typeof AppSettingsWorkspacesSplatRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/projects/$id': {
      id: '/_app/settings/projects/$id'
      path: '/$id'
      fullPath: '/settings/projects/$id'
      preLoaderRoute: typeof AppSettingsProjectsIdRouteRouteImport
      parentRoute: typeof AppSettingsProjectsRouteRoute
    }
    '/_app/settings/clients/$id': {
      id: '/_app/settings/clients/$id'
      path: '/settings/clients/$id'
      fullPath: '/settings/clients/$id'
      preLoaderRoute: typeof AppSettingsClientsIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin/workspaces/$workspaceId': {
      id: '/_app/admin/workspaces/$workspaceId'
      path: '/workspaces/$workspaceId'
      fullPath: '/admin/workspaces/$workspaceId'
      preLoaderRoute: typeof AppAdminWorkspacesWorkspaceIdRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/users/$userId': {
      id: '/_app/admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AppAdminUsersUserIdRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/settings/workspace/workinghours/': {
      id: '/_app/settings/workspace/workinghours/'
      path: '/workinghours'
      fullPath: '/settings/workspace/workinghours/'
      preLoaderRoute: typeof AppSettingsWorkspaceWorkinghoursIndexRouteImport
      parentRoute: typeof AppSettingsWorkspaceRouteRoute
    }
    '/_app/settings/workspace/team/': {
      id: '/_app/settings/workspace/team/'
      path: '/team'
      fullPath: '/settings/workspace/team/'
      preLoaderRoute: typeof AppSettingsWorkspaceTeamIndexRouteImport
      parentRoute: typeof AppSettingsWorkspaceRouteRoute
    }
    '/_app/settings/workspace/subscriptions/': {
      id: '/_app/settings/workspace/subscriptions/'
      path: '/subscriptions'
      fullPath: '/settings/workspace/subscriptions/'
      preLoaderRoute: typeof AppSettingsWorkspaceSubscriptionsIndexRouteImport
      parentRoute: typeof AppSettingsWorkspaceRouteRoute
    }
    '/_app/settings/workspace/projecthours/': {
      id: '/_app/settings/workspace/projecthours/'
      path: '/projecthours'
      fullPath: '/settings/workspace/projecthours/'
      preLoaderRoute: typeof AppSettingsWorkspaceProjecthoursIndexRouteImport
      parentRoute: typeof AppSettingsWorkspaceRouteRoute
    }
    '/_app/settings/workspace/personalization/': {
      id: '/_app/settings/workspace/personalization/'
      path: '/personalization'
      fullPath: '/settings/workspace/personalization/'
      preLoaderRoute: typeof AppSettingsWorkspacePersonalizationIndexRouteImport
      parentRoute: typeof AppSettingsWorkspaceRouteRoute
    }
    '/_app/settings/team/groups/': {
      id: '/_app/settings/team/groups/'
      path: '/settings/team/groups'
      fullPath: '/settings/team/groups/'
      preLoaderRoute: typeof AppSettingsTeamGroupsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/projects/templates/': {
      id: '/_app/settings/projects/templates/'
      path: '/templates'
      fullPath: '/settings/projects/templates/'
      preLoaderRoute: typeof AppSettingsProjectsTemplatesIndexRouteImport
      parentRoute: typeof AppSettingsProjectsRouteRoute
    }
    '/_app/settings/projects/$id/': {
      id: '/_app/settings/projects/$id/'
      path: '/'
      fullPath: '/settings/projects/$id/'
      preLoaderRoute: typeof AppSettingsProjectsIdIndexRouteImport
      parentRoute: typeof AppSettingsProjectsIdRouteRoute
    }
    '/_app/settings/clients/$id/': {
      id: '/_app/settings/clients/$id/'
      path: '/'
      fullPath: '/settings/clients/$id/'
      preLoaderRoute: typeof AppSettingsClientsIdIndexRouteImport
      parentRoute: typeof AppSettingsClientsIdRouteRoute
    }
    '/_app/admin/workspaces/$workspaceId/': {
      id: '/_app/admin/workspaces/$workspaceId/'
      path: '/'
      fullPath: '/admin/workspaces/$workspaceId/'
      preLoaderRoute: typeof AppAdminWorkspacesWorkspaceIdIndexRouteImport
      parentRoute: typeof AppAdminWorkspacesWorkspaceIdRouteRoute
    }
    '/_app/admin/users/$userId/': {
      id: '/_app/admin/users/$userId/'
      path: '/'
      fullPath: '/admin/users/$userId/'
      preLoaderRoute: typeof AppAdminUsersUserIdIndexRouteImport
      parentRoute: typeof AppAdminUsersUserIdRouteRoute
    }
    '/_app/admin/workspaces/$workspaceId/users': {
      id: '/_app/admin/workspaces/$workspaceId/users'
      path: '/users'
      fullPath: '/admin/workspaces/$workspaceId/users'
      preLoaderRoute: typeof AppAdminWorkspacesWorkspaceIdUsersRouteImport
      parentRoute: typeof AppAdminWorkspacesWorkspaceIdRouteRoute
    }
    '/_app/admin/workspaces/$workspaceId/timeline': {
      id: '/_app/admin/workspaces/$workspaceId/timeline'
      path: '/timeline'
      fullPath: '/admin/workspaces/$workspaceId/timeline'
      preLoaderRoute: typeof AppAdminWorkspacesWorkspaceIdTimelineRouteImport
      parentRoute: typeof AppAdminWorkspacesWorkspaceIdRouteRoute
    }
    '/_app/admin/workspaces/$workspaceId/tasks': {
      id: '/_app/admin/workspaces/$workspaceId/tasks'
      path: '/tasks'
      fullPath: '/admin/workspaces/$workspaceId/tasks'
      preLoaderRoute: typeof AppAdminWorkspacesWorkspaceIdTasksRouteImport
      parentRoute: typeof AppAdminWorkspacesWorkspaceIdRouteRoute
    }
    '/_app/admin/workspaces/$workspaceId/projects': {
      id: '/_app/admin/workspaces/$workspaceId/projects'
      path: '/projects'
      fullPath: '/admin/workspaces/$workspaceId/projects'
      preLoaderRoute: typeof AppAdminWorkspacesWorkspaceIdProjectsRouteImport
      parentRoute: typeof AppAdminWorkspacesWorkspaceIdRouteRoute
    }
    '/_app/admin/workspaces/$workspaceId/invoices': {
      id: '/_app/admin/workspaces/$workspaceId/invoices'
      path: '/invoices'
      fullPath: '/admin/workspaces/$workspaceId/invoices'
      preLoaderRoute: typeof AppAdminWorkspacesWorkspaceIdInvoicesRouteImport
      parentRoute: typeof AppAdminWorkspacesWorkspaceIdRouteRoute
    }
    '/_app/admin/workspaces/$workspaceId/clients': {
      id: '/_app/admin/workspaces/$workspaceId/clients'
      path: '/clients'
      fullPath: '/admin/workspaces/$workspaceId/clients'
      preLoaderRoute: typeof AppAdminWorkspacesWorkspaceIdClientsRouteImport
      parentRoute: typeof AppAdminWorkspacesWorkspaceIdRouteRoute
    }
    '/_app/admin/workspaces/$workspaceId/billing': {
      id: '/_app/admin/workspaces/$workspaceId/billing'
      path: '/billing'
      fullPath: '/admin/workspaces/$workspaceId/billing'
      preLoaderRoute: typeof AppAdminWorkspacesWorkspaceIdBillingRouteImport
      parentRoute: typeof AppAdminWorkspacesWorkspaceIdRouteRoute
    }
    '/_app/admin/workspaces/$workspaceId/audit': {
      id: '/_app/admin/workspaces/$workspaceId/audit'
      path: '/audit'
      fullPath: '/admin/workspaces/$workspaceId/audit'
      preLoaderRoute: typeof AppAdminWorkspacesWorkspaceIdAuditRouteImport
      parentRoute: typeof AppAdminWorkspacesWorkspaceIdRouteRoute
    }
    '/_app/settings/workspace/team/groups/': {
      id: '/_app/settings/workspace/team/groups/'
      path: '/team/groups'
      fullPath: '/settings/workspace/team/groups/'
      preLoaderRoute: typeof AppSettingsWorkspaceTeamGroupsIndexRouteImport
      parentRoute: typeof AppSettingsWorkspaceRouteRoute
    }
    '/_app/settings/projects/$id/tasks/': {
      id: '/_app/settings/projects/$id/tasks/'
      path: '/tasks'
      fullPath: '/settings/projects/$id/tasks/'
      preLoaderRoute: typeof AppSettingsProjectsIdTasksIndexRouteImport
      parentRoute: typeof AppSettingsProjectsIdRouteRoute
    }
    '/_app/settings/projects/$id/report/': {
      id: '/_app/settings/projects/$id/report/'
      path: '/report'
      fullPath: '/settings/projects/$id/report/'
      preLoaderRoute: typeof AppSettingsProjectsIdReportIndexRouteImport
      parentRoute: typeof AppSettingsProjectsIdRouteRoute
    }
    '/_app/settings/projects/$id/hours/': {
      id: '/_app/settings/projects/$id/hours/'
      path: '/hours'
      fullPath: '/settings/projects/$id/hours/'
      preLoaderRoute: typeof AppSettingsProjectsIdHoursIndexRouteImport
      parentRoute: typeof AppSettingsProjectsIdRouteRoute
    }
    '/_app/settings/clients/$id/projects/': {
      id: '/_app/settings/clients/$id/projects/'
      path: '/projects'
      fullPath: '/settings/clients/$id/projects/'
      preLoaderRoute: typeof AppSettingsClientsIdProjectsIndexRouteImport
      parentRoute: typeof AppSettingsClientsIdRouteRoute
    }
  }
}

interface AppAdminUsersUserIdRouteRouteChildren {
  AppAdminUsersUserIdIndexRoute: typeof AppAdminUsersUserIdIndexRoute
}

const AppAdminUsersUserIdRouteRouteChildren: AppAdminUsersUserIdRouteRouteChildren =
  {
    AppAdminUsersUserIdIndexRoute: AppAdminUsersUserIdIndexRoute,
  }

const AppAdminUsersUserIdRouteRouteWithChildren =
  AppAdminUsersUserIdRouteRoute._addFileChildren(
    AppAdminUsersUserIdRouteRouteChildren,
  )

interface AppAdminWorkspacesWorkspaceIdRouteRouteChildren {
  AppAdminWorkspacesWorkspaceIdAuditRoute: typeof AppAdminWorkspacesWorkspaceIdAuditRoute
  AppAdminWorkspacesWorkspaceIdBillingRoute: typeof AppAdminWorkspacesWorkspaceIdBillingRoute
  AppAdminWorkspacesWorkspaceIdClientsRoute: typeof AppAdminWorkspacesWorkspaceIdClientsRoute
  AppAdminWorkspacesWorkspaceIdInvoicesRoute: typeof AppAdminWorkspacesWorkspaceIdInvoicesRoute
  AppAdminWorkspacesWorkspaceIdProjectsRoute: typeof AppAdminWorkspacesWorkspaceIdProjectsRoute
  AppAdminWorkspacesWorkspaceIdTasksRoute: typeof AppAdminWorkspacesWorkspaceIdTasksRoute
  AppAdminWorkspacesWorkspaceIdTimelineRoute: typeof AppAdminWorkspacesWorkspaceIdTimelineRoute
  AppAdminWorkspacesWorkspaceIdUsersRoute: typeof AppAdminWorkspacesWorkspaceIdUsersRoute
  AppAdminWorkspacesWorkspaceIdIndexRoute: typeof AppAdminWorkspacesWorkspaceIdIndexRoute
}

const AppAdminWorkspacesWorkspaceIdRouteRouteChildren: AppAdminWorkspacesWorkspaceIdRouteRouteChildren =
  {
    AppAdminWorkspacesWorkspaceIdAuditRoute:
      AppAdminWorkspacesWorkspaceIdAuditRoute,
    AppAdminWorkspacesWorkspaceIdBillingRoute:
      AppAdminWorkspacesWorkspaceIdBillingRoute,
    AppAdminWorkspacesWorkspaceIdClientsRoute:
      AppAdminWorkspacesWorkspaceIdClientsRoute,
    AppAdminWorkspacesWorkspaceIdInvoicesRoute:
      AppAdminWorkspacesWorkspaceIdInvoicesRoute,
    AppAdminWorkspacesWorkspaceIdProjectsRoute:
      AppAdminWorkspacesWorkspaceIdProjectsRoute,
    AppAdminWorkspacesWorkspaceIdTasksRoute:
      AppAdminWorkspacesWorkspaceIdTasksRoute,
    AppAdminWorkspacesWorkspaceIdTimelineRoute:
      AppAdminWorkspacesWorkspaceIdTimelineRoute,
    AppAdminWorkspacesWorkspaceIdUsersRoute:
      AppAdminWorkspacesWorkspaceIdUsersRoute,
    AppAdminWorkspacesWorkspaceIdIndexRoute:
      AppAdminWorkspacesWorkspaceIdIndexRoute,
  }

const AppAdminWorkspacesWorkspaceIdRouteRouteWithChildren =
  AppAdminWorkspacesWorkspaceIdRouteRoute._addFileChildren(
    AppAdminWorkspacesWorkspaceIdRouteRouteChildren,
  )

interface AppAdminRouteRouteChildren {
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminUsersUserIdRouteRoute: typeof AppAdminUsersUserIdRouteRouteWithChildren
  AppAdminWorkspacesWorkspaceIdRouteRoute: typeof AppAdminWorkspacesWorkspaceIdRouteRouteWithChildren
  AppAdminNotificationsIndexRoute: typeof AppAdminNotificationsIndexRoute
  AppAdminStatsIndexRoute: typeof AppAdminStatsIndexRoute
  AppAdminSubscriptionsIndexRoute: typeof AppAdminSubscriptionsIndexRoute
  AppAdminUsersIndexRoute: typeof AppAdminUsersIndexRoute
  AppAdminWorkspacesIndexRoute: typeof AppAdminWorkspacesIndexRoute
}

const AppAdminRouteRouteChildren: AppAdminRouteRouteChildren = {
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminUsersUserIdRouteRoute: AppAdminUsersUserIdRouteRouteWithChildren,
  AppAdminWorkspacesWorkspaceIdRouteRoute:
    AppAdminWorkspacesWorkspaceIdRouteRouteWithChildren,
  AppAdminNotificationsIndexRoute: AppAdminNotificationsIndexRoute,
  AppAdminStatsIndexRoute: AppAdminStatsIndexRoute,
  AppAdminSubscriptionsIndexRoute: AppAdminSubscriptionsIndexRoute,
  AppAdminUsersIndexRoute: AppAdminUsersIndexRoute,
  AppAdminWorkspacesIndexRoute: AppAdminWorkspacesIndexRoute,
}

const AppAdminRouteRouteWithChildren = AppAdminRouteRoute._addFileChildren(
  AppAdminRouteRouteChildren,
)

interface AppDashboardRouteRouteChildren {
  AppDashboardIndexRoute: typeof AppDashboardIndexRoute
  AppDashboardContingentIndexRoute: typeof AppDashboardContingentIndexRoute
  AppDashboardDetailedIndexRoute: typeof AppDashboardDetailedIndexRoute
  AppDashboardSchedulesIndexRoute: typeof AppDashboardSchedulesIndexRoute
}

const AppDashboardRouteRouteChildren: AppDashboardRouteRouteChildren = {
  AppDashboardIndexRoute: AppDashboardIndexRoute,
  AppDashboardContingentIndexRoute: AppDashboardContingentIndexRoute,
  AppDashboardDetailedIndexRoute: AppDashboardDetailedIndexRoute,
  AppDashboardSchedulesIndexRoute: AppDashboardSchedulesIndexRoute,
}

const AppDashboardRouteRouteWithChildren =
  AppDashboardRouteRoute._addFileChildren(AppDashboardRouteRouteChildren)

interface AppSuperviseRouteRouteChildren {
  AppSuperviseIndexRoute: typeof AppSuperviseIndexRoute
  AppSuperviseActivityIndexRoute: typeof AppSuperviseActivityIndexRoute
  AppSuperviseRulebreaksIndexRoute: typeof AppSuperviseRulebreaksIndexRoute
  AppSuperviseUserIndexRoute: typeof AppSuperviseUserIndexRoute
  AppSuperviseWorkinghoursIndexRoute: typeof AppSuperviseWorkinghoursIndexRoute
}

const AppSuperviseRouteRouteChildren: AppSuperviseRouteRouteChildren = {
  AppSuperviseIndexRoute: AppSuperviseIndexRoute,
  AppSuperviseActivityIndexRoute: AppSuperviseActivityIndexRoute,
  AppSuperviseRulebreaksIndexRoute: AppSuperviseRulebreaksIndexRoute,
  AppSuperviseUserIndexRoute: AppSuperviseUserIndexRoute,
  AppSuperviseWorkinghoursIndexRoute: AppSuperviseWorkinghoursIndexRoute,
}

const AppSuperviseRouteRouteWithChildren =
  AppSuperviseRouteRoute._addFileChildren(AppSuperviseRouteRouteChildren)

interface AppSettingsProjectsIdRouteRouteChildren {
  AppSettingsProjectsIdIndexRoute: typeof AppSettingsProjectsIdIndexRoute
  AppSettingsProjectsIdHoursIndexRoute: typeof AppSettingsProjectsIdHoursIndexRoute
  AppSettingsProjectsIdReportIndexRoute: typeof AppSettingsProjectsIdReportIndexRoute
  AppSettingsProjectsIdTasksIndexRoute: typeof AppSettingsProjectsIdTasksIndexRoute
}

const AppSettingsProjectsIdRouteRouteChildren: AppSettingsProjectsIdRouteRouteChildren =
  {
    AppSettingsProjectsIdIndexRoute: AppSettingsProjectsIdIndexRoute,
    AppSettingsProjectsIdHoursIndexRoute: AppSettingsProjectsIdHoursIndexRoute,
    AppSettingsProjectsIdReportIndexRoute:
      AppSettingsProjectsIdReportIndexRoute,
    AppSettingsProjectsIdTasksIndexRoute: AppSettingsProjectsIdTasksIndexRoute,
  }

const AppSettingsProjectsIdRouteRouteWithChildren =
  AppSettingsProjectsIdRouteRoute._addFileChildren(
    AppSettingsProjectsIdRouteRouteChildren,
  )

interface AppSettingsProjectsRouteRouteChildren {
  AppSettingsProjectsIdRouteRoute: typeof AppSettingsProjectsIdRouteRouteWithChildren
  AppSettingsProjectsIndexRoute: typeof AppSettingsProjectsIndexRoute
  AppSettingsProjectsTemplatesIndexRoute: typeof AppSettingsProjectsTemplatesIndexRoute
}

const AppSettingsProjectsRouteRouteChildren: AppSettingsProjectsRouteRouteChildren =
  {
    AppSettingsProjectsIdRouteRoute:
      AppSettingsProjectsIdRouteRouteWithChildren,
    AppSettingsProjectsIndexRoute: AppSettingsProjectsIndexRoute,
    AppSettingsProjectsTemplatesIndexRoute:
      AppSettingsProjectsTemplatesIndexRoute,
  }

const AppSettingsProjectsRouteRouteWithChildren =
  AppSettingsProjectsRouteRoute._addFileChildren(
    AppSettingsProjectsRouteRouteChildren,
  )

interface AppSettingsWorkspaceRouteRouteChildren {
  AppSettingsWorkspaceIndexRoute: typeof AppSettingsWorkspaceIndexRoute
  AppSettingsWorkspacePersonalizationIndexRoute: typeof AppSettingsWorkspacePersonalizationIndexRoute
  AppSettingsWorkspaceProjecthoursIndexRoute: typeof AppSettingsWorkspaceProjecthoursIndexRoute
  AppSettingsWorkspaceSubscriptionsIndexRoute: typeof AppSettingsWorkspaceSubscriptionsIndexRoute
  AppSettingsWorkspaceTeamIndexRoute: typeof AppSettingsWorkspaceTeamIndexRoute
  AppSettingsWorkspaceWorkinghoursIndexRoute: typeof AppSettingsWorkspaceWorkinghoursIndexRoute
  AppSettingsWorkspaceTeamGroupsIndexRoute: typeof AppSettingsWorkspaceTeamGroupsIndexRoute
}

const AppSettingsWorkspaceRouteRouteChildren: AppSettingsWorkspaceRouteRouteChildren =
  {
    AppSettingsWorkspaceIndexRoute: AppSettingsWorkspaceIndexRoute,
    AppSettingsWorkspacePersonalizationIndexRoute:
      AppSettingsWorkspacePersonalizationIndexRoute,
    AppSettingsWorkspaceProjecthoursIndexRoute:
      AppSettingsWorkspaceProjecthoursIndexRoute,
    AppSettingsWorkspaceSubscriptionsIndexRoute:
      AppSettingsWorkspaceSubscriptionsIndexRoute,
    AppSettingsWorkspaceTeamIndexRoute: AppSettingsWorkspaceTeamIndexRoute,
    AppSettingsWorkspaceWorkinghoursIndexRoute:
      AppSettingsWorkspaceWorkinghoursIndexRoute,
    AppSettingsWorkspaceTeamGroupsIndexRoute:
      AppSettingsWorkspaceTeamGroupsIndexRoute,
  }

const AppSettingsWorkspaceRouteRouteWithChildren =
  AppSettingsWorkspaceRouteRoute._addFileChildren(
    AppSettingsWorkspaceRouteRouteChildren,
  )

interface AppSettingsClientsIdRouteRouteChildren {
  AppSettingsClientsIdIndexRoute: typeof AppSettingsClientsIdIndexRoute
  AppSettingsClientsIdProjectsIndexRoute: typeof AppSettingsClientsIdProjectsIndexRoute
}

const AppSettingsClientsIdRouteRouteChildren: AppSettingsClientsIdRouteRouteChildren =
  {
    AppSettingsClientsIdIndexRoute: AppSettingsClientsIdIndexRoute,
    AppSettingsClientsIdProjectsIndexRoute:
      AppSettingsClientsIdProjectsIndexRoute,
  }

const AppSettingsClientsIdRouteRouteWithChildren =
  AppSettingsClientsIdRouteRoute._addFileChildren(
    AppSettingsClientsIdRouteRouteChildren,
  )

interface AppRouteRouteChildren {
  AppAdminRouteRoute: typeof AppAdminRouteRouteWithChildren
  AppDashboardRouteRoute: typeof AppDashboardRouteRouteWithChildren
  AppSuperviseRouteRoute: typeof AppSuperviseRouteRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppSettingsProjectsRouteRoute: typeof AppSettingsProjectsRouteRouteWithChildren
  AppSettingsWorkspaceRouteRoute: typeof AppSettingsWorkspaceRouteRouteWithChildren
  AppAboutIndexRoute: typeof AppAboutIndexRoute
  AppAutomationIndexRoute: typeof AppAutomationIndexRoute
  AppCalendarTimerIndexRoute: typeof AppCalendarTimerIndexRoute
  AppCalendarIndexRoute: typeof AppCalendarIndexRoute
  AppFeedIndexRoute: typeof AppFeedIndexRoute
  AppOnboardingIndexRoute: typeof AppOnboardingIndexRoute
  AppProfitabilityIndexRoute: typeof AppProfitabilityIndexRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
  AppTeamActivityIndexRoute: typeof AppTeamActivityIndexRoute
  AppTestingIndexRoute: typeof AppTestingIndexRoute
  AppTimerIndexRoute: typeof AppTimerIndexRoute
  AppSettingsClientsIdRouteRoute: typeof AppSettingsClientsIdRouteRouteWithChildren
  AppSettingsWorkspacesSplatRoute: typeof AppSettingsWorkspacesSplatRoute
  AppAccountProfileIndexRoute: typeof AppAccountProfileIndexRoute
  AppSettingsClientsIndexRoute: typeof AppSettingsClientsIndexRoute
  AppSettingsTagsIndexRoute: typeof AppSettingsTagsIndexRoute
  AppSettingsTeamIndexRoute: typeof AppSettingsTeamIndexRoute
  AppSettingsWorkspacesIndexRoute: typeof AppSettingsWorkspacesIndexRoute
  AppSettingsTeamGroupsIndexRoute: typeof AppSettingsTeamGroupsIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppAdminRouteRoute: AppAdminRouteRouteWithChildren,
  AppDashboardRouteRoute: AppDashboardRouteRouteWithChildren,
  AppSuperviseRouteRoute: AppSuperviseRouteRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppSettingsProjectsRouteRoute: AppSettingsProjectsRouteRouteWithChildren,
  AppSettingsWorkspaceRouteRoute: AppSettingsWorkspaceRouteRouteWithChildren,
  AppAboutIndexRoute: AppAboutIndexRoute,
  AppAutomationIndexRoute: AppAutomationIndexRoute,
  AppCalendarTimerIndexRoute: AppCalendarTimerIndexRoute,
  AppCalendarIndexRoute: AppCalendarIndexRoute,
  AppFeedIndexRoute: AppFeedIndexRoute,
  AppOnboardingIndexRoute: AppOnboardingIndexRoute,
  AppProfitabilityIndexRoute: AppProfitabilityIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppTeamActivityIndexRoute: AppTeamActivityIndexRoute,
  AppTestingIndexRoute: AppTestingIndexRoute,
  AppTimerIndexRoute: AppTimerIndexRoute,
  AppSettingsClientsIdRouteRoute: AppSettingsClientsIdRouteRouteWithChildren,
  AppSettingsWorkspacesSplatRoute: AppSettingsWorkspacesSplatRoute,
  AppAccountProfileIndexRoute: AppAccountProfileIndexRoute,
  AppSettingsClientsIndexRoute: AppSettingsClientsIndexRoute,
  AppSettingsTagsIndexRoute: AppSettingsTagsIndexRoute,
  AppSettingsTeamIndexRoute: AppSettingsTeamIndexRoute,
  AppSettingsWorkspacesIndexRoute: AppSettingsWorkspacesIndexRoute,
  AppSettingsTeamGroupsIndexRoute: AppSettingsTeamGroupsIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface TeamsRouteRouteChildren {
  TeamsLoginIndexRoute: typeof TeamsLoginIndexRoute
  TeamsTabsConfigIndexRoute: typeof TeamsTabsConfigIndexRoute
}

const TeamsRouteRouteChildren: TeamsRouteRouteChildren = {
  TeamsLoginIndexRoute: TeamsLoginIndexRoute,
  TeamsTabsConfigIndexRoute: TeamsTabsConfigIndexRoute,
}

const TeamsRouteRouteWithChildren = TeamsRouteRoute._addFileChildren(
  TeamsRouteRouteChildren,
)

interface AppRouteChildren {
  AppSplatRoute: typeof AppSplatRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSplatRoute: AppSplatRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  TeamsRouteRoute: TeamsRouteRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  TeamsTabsConfigRoute: TeamsTabsConfigRoute,
  InvalidWorkspaceIndexRoute: InvalidWorkspaceIndexRoute,
  NotFoundIndexRoute: NotFoundIndexRoute,
  AuthTeamsIndexRoute: AuthTeamsIndexRoute,
  SettingsProjectviewIdReportRoute: SettingsProjectviewIdReportRoute,
  SettingsProjectviewIdIndexRoute: SettingsProjectviewIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
